import { Box } from '@stitch-fix/mode-react';
import CategoriesCarousel, { CategoriesCarouselProps } from '@stitch-fix/mode-react/CategoriesCarousel';
import { CategorySetPageFragment } from '../../queries/getCategorySetPageAtBuildTime';
import { ShopCategorySetModule } from '../../types/definitions/vendor/graphql-schema.d';
import { businessLineToRoute } from '../../utils/routingHelper';
import { formatCategoryCards } from '../CategoryCardsModule/utils';
import Link from '../Link';
export type MoreCategoriesModuleProps = Pick<ShopCategorySetModule, 'cta'> & Pick<CategoriesCarouselProps, 'endCard' | 'variant'> & {
  categorySet?: CategorySetPageFragment['categorySet'];
};
export const MAX_SLIDES = 8;
const CategoriesCarouselModule = ({
  categorySet,
  cta,
  endCard,
  variant
}: MoreCategoriesModuleProps) => {
  const categorySetId = categorySet?.id || '';
  const categoryCards = categorySet?.cards.slice(0, MAX_SLIDES).map(card => formatCategoryCards({
    ...card,
    description: null,
    // override description returned from the graph for this carousel
    href: `/${businessLineToRoute[card.category.businessLine]}/clothing/${categorySet.id}/${card.category.id}`,
    linkAs: Link
  }));
  if (endCard) {
    const endCardCTA = endCard.cta;

    // hardcode the end card CTA text
    endCardCTA.text = 'Shop more';
  }
  return <Box mt={2}>
      <CategoriesCarousel ariaLabel="Shop more categories" categorySetId={categorySetId} categoryCards={categoryCards} endCard={endCard} moduleHeader={{
      header: 'Shop more categories',
      cta: (cta && {
        linkAs: Link,
        text: 'Shop more',
        url: cta.destinationPath
      }) ?? undefined
    }} variant={variant} />
    </Box>;
};
export default CategoriesCarouselModule;